// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalBodyWrapper_wrapper__2aisV","body":"ModalBodyWrapper_body__3QeHE","isDesktop":"ModalBodyWrapper_isDesktop__bdxIG","closeIcon":"ModalBodyWrapper_closeIcon__25y_B"};